<template>
  <div class="cf-flex cf-flex--column cf-flex--align-center">
    <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-full-width">
      <div
        v-if="!savedCards.areLoading && savedCards.cards.length === 0"
        class="cf-flex cf-flex--column cf-flex--justify-center cf-flex--gap-16 cf-text-align-center cf-padding-top-16"
      >
        <img
          class="cf-illustration cf-illustration--gift-card"
          alt="Gift Card"
          src="/images/illustrations/gift-card.svg"
        >

        <h2 class="cf-title cf-title--2">
          Add a Credit Card
        </h2>

        <p class="cf-subtitle cf-subtitle--2">
          It seems you don't have any saved credit cards. You can save a card here or during checkout.
        </p>
      </div>

      <cf-saved-credit-cards :can-select-card="false" />

      <button
        v-if="!savedCards.areLoading"
        type="button"
        class="cf-button cf-button--primary cf-button--lg cf-align-self-center"
        @click="$openModal('addPaymentMethod')"
      >
        Add Card
      </button>
    </div>

    <!-- Add Card Modal -->
    <modal
      name="addPaymentMethod"
      modal-style="compact"
    >
      <Teleport
        defer
        to="#portal-modal-header-target"
      >
        Add Card
      </Teleport>

      <cf-validated-form
        name="addPaymentMethod"
        :disabled="savedCards.isCreating"
        @valid-submit="addCardSubmitHandler"
      >
        <div class="cf-flex cf-flex--column cf-flex--gap-12 cf-padding-y-16">
          <p class="cf-subtitle cf-subtitle--2">
            Enter your credit card information below.
          </p>

          <cf-credit-card-form
            ref="cardInformation"
            :is-checkout-flow="false"
            :payment-gateway="merchant.defaultPaymentGateway"
            :require-billing-address="requireBillingAddress"
            @success="cardInformationSuccessHandler"
          />

          <h5
            v-if="content.PaymentScreen.metadata.addCreditCardTerms"
            class="cf-title cf-title--5 cf-text-align-left"
            v-html="content.PaymentScreen.metadata.addCreditCardTerms"
          />

          <button
            :class="['cf-button cf-button--primary cf-button--lg', { 'cf-button--loading': savedCards.isCreating }]"
            type="submit"
          >
            Save Card
          </button>
        </div>
      </cf-validated-form>
    </modal>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfSavedCreditCards from '@/view/components/globals/cf-saved-credit-cards/index.vue';
  import CfCreditCardForm from '@/view/components/globals/cf-payment-methods/cf-credit-card-form/index.vue';
  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';


  export default {
    name: 'CreditCardsPage',

    components: {
      CfSavedCreditCards,
      CfCreditCardForm,
      CfValidatedForm
    },

    metaInfo() {
      return {
        title: 'Credit Cards'
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('savedCards', ['savedCards']),

      requireBillingAddress() {
        const selectedLocationCreditCardMethod = this.selectedLocation.paymentGateway.methods.creditCard;

        return selectedLocationCreditCardMethod ? selectedLocationCreditCardMethod.requireFullBillingAddress
          : this.merchant.defaultPaymentGateway.methods.creditCard.requireFullBillingAddress;
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      async createdHandler() {
        await this.$store.dispatch('savedCards/getCards');
      },

      addCardSubmitHandler() {
        this.$refs.cardInformation.submit();

        // this.$triggerGoogleTrackingEvent('AddNewCreditCard', 'Account');

        this.$triggerNewRelicEvent('AddNewCreditCard', 'Information', 'Added New Credit Card');
      },

      async cardInformationSuccessHandler({ paymentMethod }) {
        const payload = {
          cardInformation: paymentMethod,
          isSilentNotifiction: false
        };

        await this.$store.dispatch('savedCards/createCard', payload);

        this.$closeModal('addPaymentMethod');
      }
    }
  };
</script>
